import {ellipsis} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {ResourceMap} from '../../../../libs/shared/core/src/store/commonAppTypes';
import {Dropdown} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownList} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {buildCalendarDisplayName} from '../../../helpers/models/calendarVersionHelpers';
import {CalendarModel} from '../../../models/api/calendarModel';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {StyledCalendarDropdownBoxCoordinator} from './calendarDropdownBoxBase';

/*
 * Props.
 */

export interface SelectedCalendarData {
  calendar: CalendarModel;
  calendarVersion: CalendarVersionModel;
}

interface CalendarDropdownBoxProps {
  selectedCalendarVersion: CalendarVersionModel;
  calendars: ResourceMap<CalendarModel>;
  calendarVersions: ReadonlyArray<CalendarVersionModel>;
  onCalendarDataSelect: (data: SelectedCalendarData) => void;
  className?: string;
  isDisabled?: boolean;
}

/*
 * Styles.
 */

const StyledValueDiv = styled.div`
  display: grid;
`;

const StyledNameDiv = styled.div`
  ${ellipsis()};
`;

/*
 * Component.
 */

export const CalendarDropdownBox: FC<CalendarDropdownBoxProps> = (props) => (
  <StyledCalendarDropdownBoxCoordinator
    value={renderValue(props)}
    renderDropdown={(popoverProps) => renderDropdown(popoverProps, props)}
    boxClassName={props.className}
    isDisabled={props.isDisabled}
  />
);

function renderValue(props: CalendarDropdownBoxProps) {
  return (
    <StyledValueDiv>
      <StyledNameDiv>
        {buildCalendarDisplayName(props.selectedCalendarVersion, props.calendars)}
      </StyledNameDiv>
    </StyledValueDiv>
  );
}

function renderDropdown(popoverProps: PopoverTransferProps, props: CalendarDropdownBoxProps) {
  return (
    <Dropdown {...popoverProps}>
      <DropdownList {...popoverProps}>{props.calendarVersions.map((v) => renderItem(v, props))}</DropdownList>
    </Dropdown>
  );
}

function renderItem(calendarVersion: CalendarVersionModel, props: CalendarDropdownBoxProps) {
  const isChecked = calendarVersion.id === props.selectedCalendarVersion.id;
  const calendar = props.calendars[calendarVersion.calendarId];
  if (!calendar) {
    return null;
  }

  return (
    <DropdownItem
      key={calendarVersion.id}
      isChecked={isChecked}
      onSelect={() => props.onCalendarDataSelect({calendarVersion, calendar})}
    >
      <DropdownItemContent isChecked={isChecked}>
        {buildCalendarDisplayName(calendarVersion, props.calendars)}
      </DropdownItemContent>
    </DropdownItem>
  );
}
